import React from "react";

const ContractTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="card-tabs">
      <nav className="tabs">
        <button
          onClick={() => setActiveTab("all")}
          className={`tab ${activeTab === "all" ? "active-tab" : ""}`}
        >
          All Data Contracts
        </button>
        <button
          onClick={() => setActiveTab("mySubscriptions")}
          className={`tab ${activeTab === "mySubscriptions" ? "active-tab" : ""}`}
        >
          My Subscriptions
        </button>
        <button
          onClick={() => setActiveTab("myContracts")}
          className={`tab ${activeTab === "myContracts" ? "active-tab" : ""}`}
        >
          My Contracts
        </button>
      </nav>
    </div>
  );
};

export default ContractTabs;